import { HttpResponse } from '@angular/common/http';
import { MediaItem } from './media-item';
import { MediaItemDto } from './media-item.dto';

export class PaginatedDto {
    readonly payload: MediaItem[];
    readonly total: number;

    constructor(response: HttpResponse<MediaItemDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new MediaItem(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
